import React from 'react';

import {Button, Dialogue, Icon, Modal, Text} from '@albert-io/atomic';

import './lti-cell.scss';

interface LtiSyncModalProps {
  ltiPlatformName: string;
  syncLti: () => Promise<boolean>;
  isRequestPending: boolean;
  onDismiss: () => void;
}

/**
 * Confirmation shown before the first grade sync, explaining when/how grades flow to the LMS.
 * Extracted from LtiCell so the v2 dashboard assignment row reuses the same confirm step.
 */
export const LtiSyncModal = ({
  ltiPlatformName,
  syncLti,
  isRequestPending,
  onDismiss
}: LtiSyncModalProps) => {
  const onSync = async () => {
    const success = await syncLti();
    if (success) {
      onDismiss();
    }
  };

  return (
    <Modal ariaLabel='Confirm Lti Sync Modal' handleClose={onDismiss}>
      {({CloseButtonWrapper}) => (
        <Dialogue inModal hideCloseBtn className='lti-cell__sync-modal'>
          <Dialogue.Body className='lti-cell__sync-modal--body'>
            <div className='lti-cell__sync-modal--info-icon'>
              <Icon icon='info-circle' iconStyle='light' />
            </div>
            <Text className='text-center content-primary'>
              Grades will update in {ltiPlatformName} once explanations are made available to
              students in Albert, depending on your assignment settings.
            </Text>
            <Text italic className='text-center content-tertiary'>
              You can sync this assignment at any time from your class assignment list.
            </Text>
          </Dialogue.Body>
          <div className='lti-cell__sync-modal--button-group'>
            <CloseButtonWrapper>
              <Button
                variant='outlined'
                className='lti-cell__sync-modal--button'
                onClick={onDismiss}
              >
                I&apos;ll do this later
              </Button>
            </CloseButtonWrapper>
            <Button
              disabled={isRequestPending}
              className='lti-cell__sync-modal--button'
              onClick={onSync}
            >
              Sync
            </Button>
          </div>
        </Dialogue>
      )}
    </Modal>
  );
};
